import { Injectable, NgZone } from '@angular/core';
import { distinctUntilChanged, switchMap, take } from 'rxjs';
import { filterNil } from '@ngneat/elf';
import {
  ActionsQueryParamKeys,
  checkIfQueryParamSetToTrue,
  checkIfSpaceViewMode,
  checkIfStandAloneMode,
  SpaceViewMode,
} from '../common/utils/actions-query-params-util';
import { SpaceRepository } from '../state/space.repository';
import { enterZone } from '../utilities/ZoneUtils';
import { SessionSharedDataService, SessionView } from './session-shared-data.service';
import { SpaceLeaderModeService } from './space-leader-mode.service';
import { SpacesSwitcherService } from './spaces-switcher.service';

@Injectable({
  providedIn: 'root',
})
export class ActionsQueryParamsService {
  constructor(
    private sessionSharedDataService: SessionSharedDataService,
    private spaceRepo: SpaceRepository,
    private spaceLeaderModeService: SpaceLeaderModeService,
    private spacesSwitcherService: SpacesSwitcherService,
    private zone: NgZone,
  ) {
    this.setGalleryViewToDefaultSubscription();
  }

  checkShouldStartCallAutomatically(): boolean {
    return (
      this.spacesSwitcherService.isEnabled ||
      checkIfQueryParamSetToTrue(ActionsQueryParamKeys.AUTO_START_CALL)
    );
  }

  checkIfGalleryViewIsSetToDefault(): boolean {
    return checkIfQueryParamSetToTrue(ActionsQueryParamKeys.DEFAULT_GALLERY_VIEW);
  }

  checkIfAutoLocalRecordingIsEnabled(): boolean {
    return checkIfQueryParamSetToTrue(ActionsQueryParamKeys.AUTO_LOCAL_RECORDING);
  }

  checkIfShouldSkipPrecallSetup(): boolean {
    return (
      this.spacesSwitcherService.isEnabled ||
      checkIfQueryParamSetToTrue(ActionsQueryParamKeys.SKIP_DEVICE_SETUP)
    );
  }

  checkIfShouldSkipCallHostCheck(): boolean {
    return checkIfQueryParamSetToTrue(ActionsQueryParamKeys.SKIP_CALL_HOST_CHECK);
  }

  checkIfStandAloneModeIsEnabled(): boolean {
    return checkIfStandAloneMode(
      this.spaceRepo.activeSpace?.institution?.settings?.hideSpaceBackLinks,
    );
  }

  checkIfWhiteboardOnlyMode(): boolean {
    return checkIfSpaceViewMode(SpaceViewMode.WHITEBOARD_ONLY);
  }

  private setGalleryViewToDefaultSubscription() {
    this.spaceRepo.activeSpaceId$
      .pipe(distinctUntilChanged(), filterNil())
      .pipe(
        switchMap(() =>
          this.spaceRepo.activeSpaceSelectedBoardUid$.pipe(take(1), enterZone(this.zone)),
        ),
      )
      .subscribe(() => {
        if (
          this.checkIfGalleryViewIsSetToDefault() &&
          !this.spaceLeaderModeService.currentUserIsBeingLed()
        ) {
          this.sessionSharedDataService.sessionView.switchToSessionView(SessionView.GALLERY_VIEW);
        }
      });
  }
}
